import { useTranslation } from "react-i18next";
import { ButtonWithWarningDialog } from "../Buttons/Buttons";
import { getObjectReferenceUnlinkConfirmMessage } from "./utils";

export function ObjectReferenceChangeConfirmDialog({
  show,
  onClose,
  onConfirm,
  heading,
  message,
}: {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  heading?: string;
  message?: string;
}) {
  const { t } = useTranslation();

  return (
    <ButtonWithWarningDialog
      testid="object-reference-change-confirm-dialog"
      heading={heading ?? t("Save Changes?")}
      confirmMessage={message ?? getObjectReferenceUnlinkConfirmMessage(t)}
      handleConfirm={async () => {
        await onConfirm();
      }}
      handleCancel={onClose}
      showSecondButton={true}
      saveBtnTitle={t("Confirm")}
      showAlignCloseButton={true}
      openModalDirectly={show}
    />
  );
}
